module.exports = __webpack_public_path__ + "assets/img/social/github-icon.69702c8d41191f3b095fab6c750c178c.svg";